import { createContext } from "react";

/**
 * Context-guarda do inbox de notificações (exceção §1 — createContext puro).
 * Value sentinel: `{ mounted: true }`. Dados vivem no Zustand, não aqui.
 *
 * @typedef {{ mounted: true }} NotificationsContextValue
 */

export const NotificationsContext = createContext(
  /** @type {NotificationsContextValue|null} */ (null),
);
